<template>
    <v-layout class="main-carousel-slider-block">
        <v-carousel
            :show-arrows="false"
            cycle
            height="auto"
            class="main-carousel-slider"
        >
            <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-for="(slide, key) in data" :key="key">
                <v-flex d-flex class="main-carousel-slider-item-content">
                    <v-flex class="main-carousel-slider-icons">
                        <img :src="slide.img1"/>
                        <img :src="slide.img2"/>
                    </v-flex>
                    <div class="main-carousel-slider-text">
                        {{slide.text}}
                    </div>
                </v-flex>
            </v-carousel-item>
        </v-carousel>
    </v-layout>
</template>
<script>
    export default {
        props: ['slides'],
        data: () => ({
            data: [
                {
                    img1: '/svg/grimacing-face_3.svg',
                    img2: '/svg/alarm-clock.svg',
                    text: '',
                },
                {
                    img1: '/svg/alarm-clock.svg',
                    img2: '/svg/man-police-officer.svg',
                    text: '',
                },
                {
                    img1: '/svg/ok-hand.svg',
                    img2: '/svg/check-mark.svg',
                    text: '',
                },
            ],
        }),
        mounted() {
            if (this.slides) {
                this.slides.map((slide, key) => {
                    this.data[key].text = slide
                })
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/services/ServicesCarousel.vue